import React from 'react';
import { getManagementCompanyPath } from '@finect/front-resources/Products';
import styled, { useTheme } from 'styled-components';
import { AppLink } from '@finect/tabular-core/AppLink';
import { Flex } from '@finect/tabular-core/Flex';
import { getManagementCompanyIconUrl } from '../utils';
var Inner = styled(Flex).withConfig({
  displayName: "Small__Inner",
  componentId: "sc-frs2g7-0"
})(["align-items:center;width:100%;height:50px;border:1px solid ", ";border-radius:8px;box-shadow:0 0 4px rgb(46 46 51 / 0.04);margin-right:0;background-color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.terciaryL;
}, function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.cardsBackgroundColor);
});
var Image = styled.img.withConfig({
  displayName: "Small__Image",
  componentId: "sc-frs2g7-1"
})(["width:100%;height:100%;border-top-left-radius:8px;border-bottom-left-radius:8px;"]);
var ImageContent = styled.div.withConfig({
  displayName: "Small__ImageContent",
  componentId: "sc-frs2g7-2"
})(["width:48px;height:48px;"]);
var Content = styled.div.withConfig({
  displayName: "Small__Content",
  componentId: "sc-frs2g7-3"
})(["flex-grow:1;padding-left:12px;font-size:16px;font-weight:16px;text-align:center;a{display:block;}"]);
export var Small = function Small(_ref3) {
  var managementCompany = _ref3.managementCompany,
    productType = _ref3.productType;
  var theme = useTheme();
  var imageSrc = getManagementCompanyIconUrl(managementCompany);
  var url = getManagementCompanyPath(theme, productType, managementCompany);
  return React.createElement(Inner, null, React.createElement(ImageContent, null, React.createElement(AppLink, {
    href: url
  }, React.createElement(Image, {
    src: imageSrc
  }))), React.createElement(Content, null, React.createElement(AppLink, {
    href: url
  }, managementCompany.name)));
};